
import React from "react";
import ManageGAForm from "./ManageGAForm";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function ManageGAPage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ManageGAForm />
    </DashboardLayout>
  );
}

export default ManageGAPage;
